import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("mobile-header-styles__drawercontentoutercontainer-1heegw", {
  flexGrow: "1",
  width: "100%",
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  justifyContent: "space-between",
  overflowY: "scroll",
  WebkitOverflowScrolling: "touch",
  overflowX: "hidden",
  height: "100%",
  backgroundColor: "var(--system-white)",
  color: "var(--system-black)"
});
const _staticStyles2 = _cssRef("mobile-header-styles__drawerwidthcontainer-3mhsa7", {
  width: "100%"
});
const _staticStyles3 = _cssRef("mobile-header-styles__closebuttoncontainer-059fq6", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingTop: "11px",
  paddingBottom: "11px"
});
const _staticStyles4 = _cssRef("mobile-header-styles__closebutton-1drjjb", {
  alignItems: "center",
  position: "relative"
});
const _staticStyles5 = _cssRef("mobile-header-styles__directiontransitioncontainer-1slisk", {
  display: "flex",
  flexDirection: "column"
});
const _staticStyles6 = _cssRef("mobile-header-styles__sitesearchbar-36v9p6", {
  width: "100%",
  marginTop: "80px",
  paddingLeft: "24px",
  paddingRight: "24px",
  "& input": {
    border: "2px solid var(--primary-orange-500)"
  }
});
const _staticStyles7 = _cssRef("mobile-header-styles__ctasticky-2qu2x8", {
  position: "sticky",
  bottom: "0",
  width: "100%",
  zIndex: 250,
  boxShadow: "0 -2px 12px 0 #0001"
});
const _staticStyles8 = _cssRef("mobile-header-styles__headeroutercontainer-198kaz", {
  backgroundColor: "var(--system-white)",
  borderBottom: "1px solid var(--system-grey-100)"
});
const _staticStyles9 = _cssRef("mobile-header-styles__headerinnercontainer-3m5fqc", {
  display: "flex",
  padding: "11px 0",
  justifyContent: "space-between",
  height: "100%"
});
const _staticStyles0 = _cssRef("mobile-header-styles__logo-3fuk9i", {
  width: "184px",
  transition: "0.2s",
  transformOrigin: "bottom left",
  height: "53px"
});
const _staticStyles1 = _cssRef("mobile-header-styles__fixedcta-3pc8ke", {
  maxWidth: "100vw",
  fontSize: "16px",
  zIndex: 250,
  position: "fixed",
  bottom: "0",
  width: "100%",
  textAlign: "center",
  boxShadow: "0 -2px 12px 0 #0001",
  transitionProperty: "color, background-color, border-color, text-decoration-color, fill, stroke",
  transitionTimingFunction: "cubic-bezier(0.4, 0, 0.2, 1)",
  transitionDuration: "300ms",
  transition: "transform 0.15s ease-in",
  transform: "translate3d(0px, 60px, 0px)",
  ".scroll-up &": {
    transform: "none"
  },
  ".microsite-page &, .microsite-service &, .metro-state &, .locations-index &": {
    transform: "none"
  },
  "&.mobile-cta-open": {
    transform: "none"
  }
});
const _staticStyles10 = _cssRef("mobile-header-styles__mainmenulist-2s5cgx", {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: 0,
  padding: "0",
  marginTop: "12px"
});
const _staticStyles11 = _cssRef("mobile-header-styles__mainmenuitem-0bf2qn", {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "56px",
  flexShrink: 0,
  padding: "18px 12px",
  backgroundColor: "transparent",
  border: "none",
  textAlign: "left",
  cursor: "pointer",
  borderBottom: "1px solid var(--system-grey-200)",
  textDecoration: "none",
  touchAction: "manipulation",
  WebkitTapHighlightColor: "rgba(255, 255, 255, 0.1)",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)"
  },
  "& svg": {
    height: "10px",
    width: "16px",
    flexShrink: 0
  }
});
const _staticStyles12 = _cssRef("mobile-header-styles__mainmenuitemtext-1r86wi", {
  transformOrigin: "color",
  fontFamily: "Graphie, sans-serif",
  fontSize: "32px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "normal"
});
const _staticStyles13 = _cssRef("mobile-header-styles__subnavmenuitemtext-1zg6na", {
  fontSize: "26px"
});
const _staticStyles14 = _cssRef("mobile-header-styles__arrowcontainer-2vn4bb", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "24px",
  height: "24px"
});
const _staticStyles15 = _cssRef("mobile-header-styles__activearrow-18vssh", {
  color: "var(--primary-orange-500)"
});
const _staticStyles16 = _cssRef("mobile-header-styles__arrowsubnavitem-12dun0", {
  "& svg": {
    height: "16px",
    width: "16px"
  }
});
const _staticStyles17 = _cssRef("mobile-header-styles__serviceitemwithicon-0mwyp4", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  padding: "18px 12px",
  backgroundColor: "transparent",
  textAlign: "left",
  cursor: "pointer",
  border: "none",
  textDecoration: "none",
  touchAction: "manipulation",
  WebkitTapHighlightColor: "rgba(255, 255, 255, 0.1)",
  borderBottom: "1px solid var(--system-grey-200)",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.1)"
  },
  "& svg": {
    flexShrink: 0
  }
});
const _staticStyles18 = _cssRef("mobile-header-styles__level2listitem-1ngwde", {
  paddingLeft: "54px",
  fontSize: "22px"
});
const _staticStyles19 = _cssRef("mobile-header-styles__serviceitemleft-18m1gm", {
  display: "flex",
  alignItems: "center",
  gap: "8px"
});
const _staticStyles20 = _cssRef("mobile-header-styles__serviceicon-28fmen", {
  width: "36px",
  height: "36px",
  flexShrink: 0
});
import { colors } from '../../primitives/colors';
import { fontGraphie } from '../../primitives/tokens';
import { HEADER_CHROME_PADDING_Y, HEADER_LOGO_WIDTH } from '../sidebar-header/utils';
import { MEGAMENU_CATEGORY_ICON_SIZES } from '../sidebar-header/menu-item.styles';

/** L2 row icons — align <img sizes> with `serviceIcon` width/height. */
export const MOBILE_ACCORDION_ROW_ICON_SIZES = MEGAMENU_CATEGORY_ICON_SIZES;
const styles = {
  drawerContentOuterContainer: _staticStyles,
  drawerWidthContainer: _staticStyles2,
  closeButtonContainer: _staticStyles3,
  closeButton: _staticStyles4,
  directionTransitionContainer: _staticStyles5,
  siteSearchBar: _staticStyles6,
  ctaSticky: _staticStyles7,
  headerOuterContainer: _staticStyles8,
  headerInnerContainer: _staticStyles9,
  logo: _staticStyles0,
  fixedCta: _staticStyles1,
  mainMenuList: _staticStyles10,
  mainMenuItem: _staticStyles11,
  mainMenuItemText: _staticStyles12,
  subNavMenuItemText: _staticStyles13,
  arrowContainer: _staticStyles14,
  activeArrow: _staticStyles15,
  arrowSubNavItem: _staticStyles16,
  serviceItemWithIcon: _staticStyles17,
  level2ListItem: _staticStyles18,
  serviceItemLeft: _staticStyles19,
  serviceIcon: _staticStyles20
};
export default styles;